import { useLocation, Link } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();
  
  return (
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-4 bg-background-50">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-foreground-50 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <h1 className="text-xl md:text-2xl font-semibold text-foreground-800 mt-6">
          Diese Seite wurde noch nicht erstellt
        </h1>
        <p className="mt-2 text-base text-foreground-400 font-mono">{location.pathname}</p>
        <p className="mt-4 text-base md:text-lg text-foreground-500">
          Erzähl mir mehr über diese Seite, damit ich sie für dich generieren kann.
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 mt-8 px-6 py-3 rounded-full bg-primary-500 text-white font-semibold text-sm hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
        >
          <i className="ri-home-line"></i>
          <span>Zurück zur Startseite</span>
        </Link>
      </div>
    </div>
  );
}